import actions from "./actions.js";
import getters from "./getters.js";
import mutations from "./mutations.js";

export default {
    namespaced: true,
    state() {
        return {
            userTags: null,
            topFeeder: null,
            idleUsers: null,
            subCategories: null,
            mainCategories: null,
            userTransaction: null,
            detailCategories: null,
            sentimentAnalysis: null,
            misalignedResponses: null,
            feedFinalizeDetails: null,
            feedFinalizeSummaries: null,
            operationTransactions: null,
            operationServiceLevels: null,
            userModerationHiddenContents: null,
            selectedServiceLevelTimePeriods: [],
            userModerationBlockedContents: null,
            userModerationDeletedContents: null
        }
    },
    getters,
    actions,
    mutations
}